<template>
    <div class="admin_permission_wrap">
        <div class="admin_permission_top">
            <div class="admin_permission_tab">
                <ul>
                    <li @click="handleClickTab(item)"  :class="item.name == activeName ? 'active' : ''"   v-for="item in tabList"   v-text="item.label"></li>
                </ul>
            </div>
        </div>
        <div class="admin_permission_bottom">
            <template v-if="activeName == '1'">
                <div class="admin_permission_system_wrap">
                    <div class="admin_permission_system">
                        <div class="top">
                            <img src="https://download.hecoos.com/enlightv/2024-51/c977f7470af4ed909e0b3184f2d18c10.png" alt="">
                            <div>
                                <h5>系统管理员</h5>
                                <p>系统管理员拥有系统的最高权限，每个公司仅可设置一人</p>
                            </div>
                            <span>
                                <el-button size="small" type="text" @click="handleClickReplace">更换</el-button>
                            </span>
                        </div>
                        <div class="bottom">
                            <h5>当前管理员：</h5>
                            <userDetailPopover :uid="userInfo.user.id">
                                <div slot="container">
                                    <div class="custome_user_head ellipsis" >
                                        <img :src="userInfo.user.avatar" alt="">
                                        <span v-text="userInfo.user.name"></span>
                                    </div>
                                </div>
                            </userDetailPopover>

                        </div>
                    </div>
                </div>

            </template>

            <template v-if="activeName == '2'">
                <div class="admin_permission_child_wrap">
                    <div class="admin_permission_child_top">
                        <div class="prompt">分配他人为子管理员，子管理员可以辅助您进行权限分配</div>
                        <el-button size="small" type="primary" @click="handleClickAdd">添加管理员</el-button>
                    </div>
                    <div class="admin_permission_child_table">
                        <CustomVxeTable
                                ref="tableRef"
                                class="custom-table"
                                id="adminPermissionChildTable"
                                :tableData="tableData"
                                :reduceHeight="reduceHeight"
                                :isShowToolBar="true"
                                :loading="loading"
                                :empty-render="{ name: 'NotData' }"
                                :pagination.sync="pagination"
                                @handleCurrentChange="handleCurrentChange"
                                @handleSizeChange="handleSizeChange"
                                :customConfig="tableCustomConfig">
                            <vxe-column field="user" title="管理员"  min-width="200" show-overflow>
                                <template #default="{ row }">
                                    <userDetailPopover v-if="row.user" :uid="row.user.id">
                                        <div slot="container">
                                            <div class="custome_user_head ellipsis" >
                                                <img :src="row.user.avatar" alt="">
                                                <span v-text="row.user.name"></span>
                                            </div>
                                        </div>
                                    </userDetailPopover>
                                </template>
                            </vxe-column>
                            <vxe-column field="department_name" title="部门"  min-width="200" show-overflow>
                                <template #default="{ row }">
                                    <span v-if="row.user" v-text="row.user.department_name"></span>
                                </template>
                            </vxe-column>
                            <vxe-column field="created_at" title="最近编辑授权时间"  min-width="200" show-overflow></vxe-column>
                            <vxe-column field="handle" title="操作" align="center" width="60" show-overflow>
                                <template #default="{ row }">
                                    <el-button type="text" @click="handleClickDel(row)" class="danger_text">移除</el-button>
<!--                                    <span  class="handle_icon_wrap handle_icon_danger_wrap" @click.stop="handleClickDel(row)"><i class="iconfont icon-shanchu1"></i></span>-->
                                </template>
                            </vxe-column>
                            <template #empty>
                                <div class="custom-table-empty">
                                    <div class="custom-table-empty-img"></div>
                                    <p class="custom-table-empty-txt" >暂无数据</p>
                                </div>
                            </template>
                        </CustomVxeTable>


                    </div>
                </div>


            </template>
        </div>
        <AddSubAdmin :addSubAdminDialog.sync="addSubAdminDialog" :ticketId="addSubAdminDialog" @success="getTableData" v-if="addSubAdminDialog" />
        <ReplaceAdmin :replaceAdminDialog.sync="replaceAdminDialog"  @success="replaceAdminSuccess" v-if="replaceAdminDialog" />
    </div>
</template>
<script>
import {mapState} from "vuex";
import userDetailPopover from "@/components/pComponents/userDetailPopover";
import {getSubAdminList, deleteSubAdmin} from "@/api/index.js"
import {pagination} from "@/mixins";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import AddSubAdmin from  "./component/add_sub_admin"
import ReplaceAdmin from  "./component/replace_admin"
export default {
    name: "AdminPermission",
    components: {
       userDetailPopover,
        CustomVxeTable,
        AddSubAdmin,
        ReplaceAdmin
    },
    data() {
        return {
            loading:false,
            activeName: "1",
            tabList: [
                { name: "1", label: "系统管理员" },
                { name: "2", label: "系统子管理员" },
            ],
            tableData:[],
            defaultImg: require("@/assets/images/default.jpg"),
            tableCustomConfig: {
                storage:true,
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return col.column.field !== "id";
                },
                allowSort: true,
            },
            addSubAdminDialog:false,
            replaceAdminDialog:false
        };
    },
    mixins: [pagination],
    computed: {
        ...mapState(["userInfo"]),
        reduceHeight() {
            return  this.tableData.length ? 221 : 165;
        },
    },
    created() {
        if(!this.userInfo.user.is_company_admin){
            this.$router.go(-1);
        }

    },
    mounted() {
        this.getTableData()
    },
    methods: {
        handleClickTab(item) {
            this.activeName = item.name;
        },
        // 表头配置
        handleClickCustom() {
            this.$refs.tableRef.handleOpenCustomShow();
        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val.pageSize
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },
        getTableData() {
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
            }
            this.loading = true
            getSubAdminList(postData).then(res=> {
                if(res.code === 200) {
                    let {data,total} = res.data
                    this.tableData = data
                    this.pagination.total = total
                }
                this.loading = false
            })
        },
        // 添加管理员
        handleClickAdd(){
            this.addSubAdminDialog = true
        },
        // 移除
        handleClickDel(row){
            const h = this.$createElement;
            this.$msgbox({
                title: '移除',
                message: h('div', null, [
                    h('span', null, '确定移除该子管理员吗？'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                customClass: 'prompt_message_custom',
                confirmButtonText: '移除',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: 'el-button--danger danger',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                let postData = {
                    sub_admin_id : row.id
                }
                this.loading = true
                deleteSubAdmin(postData).then(res=> {
                    if(res.code === 200) {
                        this.$message.success('移除成功')
                        this.getTableData()
                    }
                    this.loading = false
                })
            }).catch(() => {

            })
        },
        // 更换系统管理员
        handleClickReplace(){
            this.replaceAdminDialog = true
        },
        // 更换之后的回调
        replaceAdminSuccess(){

        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/permission.scss";
</style>
